import { FilterConfig } from 'common/models/filter.model';
import { FILTER_ITEMS } from './constants-filter-configs';

export const MIR_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.territory,
  FILTER_ITEMS.managerName,
  FILTER_ITEMS.fieldTeam,
  FILTER_ITEMS.specialty,
];
